import { useMutation } from "@apollo/react-hooks";
import { Modal } from "@shopify/polaris";
import React from "react";

import { FETCH_SHOP_ORDERS } from "../../../graphql/mutations";
import { handleError } from "../../../helper";
import { useToastContext } from "../../shared/ToastContext";

export default function FetchOrderByStore({ open, onClose, store }) {
    const { id } = store;

    const [fetchOrderByShop, { loading }] = useMutation(FETCH_SHOP_ORDERS);

    const { toggleToast, setNotify } = useToastContext();

    const handleSubmit = React.useCallback(() => {
        if (!id) return;

        toggleToast && toggleToast(true);
        setNotify && setNotify({ err: false, msg: null });

        fetchOrderByShop({
            variables: {
                storeId: id,
            },
        })
            .then(() => {
                setNotify({
                    err: false,
                    msg: "Fetch Order for this Store success",
                });
            })
            .catch((err) => {
                setNotify({ err: true, msg: handleError(err.toString()) });
            })
            .finally(() => {
                onClose && onClose();
            });
    }, [fetchOrderByShop, id, onClose, toggleToast, setNotify]);

    return (
        <Modal
            title="Fetch Order"
            sectioned
            open={open}
            onClose={onClose}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading,
            }}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
        >
            <p>Are you sure to Fetch Order for this Store?</p>
        </Modal>
    );
}
